import CRUDHelper from "../../services/CRUDHelper";
import ResponseStore from "@shared/stores/ResponseStore";

class UserStore extends CRUDHelper {
  constructor (resourceName, rootUrl) {
    super(resourceName, rootUrl);
    this.nullifyUser();
  }

  nullifyUser () {
    this.state.user = { user_emails: [], user_mobile_numbers: [] };
  }

  async fetchCurrentUser () {
    let response = await fetch("api/v4/user");

    if (response.status === 401) {
      throw new Error("Unauthenticated");
    }

    let responseJSON = await response.json();

    if (responseJSON.success) {
      this.state.user = responseJSON.user;
      this.state.company = responseJSON.company;
    }
  }

  async logout () {
    let response = await fetch("api/v4/logout", { method: "GET" });

    return response.json();
  }

  async ensureCurrentUser () {
    if (!this.state.user.id) {
      await this.fetchCurrentUser();
    }
  }

  async rankObject (e, objectClass) {
    let data = new FormData();
    e.forEach(function (element) {
      data.append(`${objectClass}[]`, element.id);
    });

    let response = await fetch(
      "/api/v4/rank", {
        body: data,
        method: "PATCH"
      }
    );

    return response.json();
  }

  async checkUserByEmail (email) {
    let response = await fetch(`/api/v4/users/find?email=${encodeURIComponent(email)}`);

    let responseJSON = await response.json();

    return responseJSON;
  }

  async updateUserPassword (user) {
    const formData = new FormData(document.getElementById("form-card"));

    let response = await fetch(`/api/v4/users/${user.id}/update_password`, {
      body: formData,
      method: "PATCH"
    });

    ResponseStore.finishProcessing();

    return response.json();
  }

  async anonymizeUser (user) {
    let response = await fetch(`/api/v4/users/${user.id}/anonymize`, {
      method: "PATCH"
    });
    let responseJSON = await response.json();

    return responseJSON;
  }
};

export default new UserStore("user", () => "/api/v4");
